import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CandidatesFilter } from '../../models/candidates-filter';
import { CandidatesStore } from '../../store/candidates-store.service';

@Component({
  selector: 'candidate-filter',
  templateUrl: './candidate-filter.component.html',
  styleUrls: ['./candidate-filter.component.scss']
})
export class CandidateFilterComponent implements OnInit, OnDestroy {

  public skillKeyword: string;
  public location: string;
  _candidatesFilter: CandidatesFilter;
  _subscription: Subscription;

  constructor(private router: Router, private candidateStore: CandidatesStore) { }

  ngOnInit() {
    this._candidatesFilter = new CandidatesFilter();
    this._subscription = this.candidateStore.candidateSearchFilter.subscribe(filter => {
      if(!filter) {
        return;
      }

      this._candidatesFilter = filter;
      this.skillKeyword = filter.keyword;
      this.location = filter.location;
    });
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  filterCandidates(): void {
    this._candidatesFilter.keyword = this.skillKeyword;
    this._candidatesFilter.location = this.location;
    this.candidateStore.loadSearchResults(this._candidatesFilter);
    this.router.navigate(['/search-candidates']);  
  }

  

}
